module.exports = __webpack_public_path__ + "img/taiwan_1.9953b37c.png";